var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8787 15.4153C15.8787 15.5585 15.7626 15.6746 15.6194 15.6746L1.25926 15.6746C1.11612 15.6746 1 15.5585 1 15.4153L1 4.65354C1 4.5104 1.11612 4.39404 1.25926 4.39404L15.6194 4.39404C15.7626 4.39404 15.8787 4.5104 15.8787 4.65354L15.8787 15.4153Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.94971L15.8787 5.94971",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89062 5.26855H2.08519",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41016 5.26855H2.60472",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92969 5.26855H3.12425",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59653 7.66797L2.79883 7.66797L2.79883 11.4657H6.59653V7.66797Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70312 7.89453L14.1608 7.89453",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70312 9.39893L14.1608 9.39893",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70312 11.0063L14.1608 11.0063",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.56055 13.3926L14.1575 13.3926",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12109 3.61593V3.25926C3.12109 3.11612 3.23722 3 3.38036 3L17.7405 3C17.8837 3 17.9998 3.11612 17.9998 3.25926V14.0215C17.9998 14.1647 17.8837 14.2808 17.7405 14.2808H15.8295",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01172 3.875H4.20628",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5332 3.875H4.72777",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05273 3.875H5.2473",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountblack);
export default __webpack_public_path__ + "static/media/accountblack.4b92becf925c14bca154b1bbf81aff4e.svg";
export { ForwardRef as ReactComponent };